import React from "react";
import { useHistory } from "react-router-dom";
import { IoAdd, IoHome, IoLayers, IoPower, IoVideocam } from "react-icons/io5";
import { mdiRobot } from "@mdi/js";
import MdiIcon from "../../device/app/MdiIcon";
import { useAutomationFeature } from "../../../automation/AutomationProvider";

const RobotIcon = () => <MdiIcon path={mdiRobot} size="1em" />;

const TABS = [
  { key: "home", label: "Home", path: "/dashboard", icon: IoHome },
  { key: "floors", label: "Floors", path: "/floors", icon: IoLayers },
  { key: "devices", label: "Devices", path: "/devices", icon: IoPower },
  { key: "cam", label: "Camera", path: "/camera", icon: IoVideocam },
  { key: "automation", label: "Automation", path: "/automations", icon: RobotIcon },
];

// Which tab a page belongs to, so the tab bar can highlight it.
export const tabForPath = (pathname = "") => {
  const page = pathname.toLowerCase();
  if (["/dashboard", "/favourites", "/automations/history"].includes(page)) return "home";
  if (["/floors", "/property", "/room"].includes(page)) return "floors";
  if (page === "/devices") return "devices";
  if (page === "/camera") return "cam";
  if (["/automations", "/automation"].includes(page)) return "automation";
  return null;
};

const Tab = ({ tab, active, onSelect }) => {
  const Icon = tab.icon;
  return (
    <button
      type="button"
      className={`hx-tab ${active ? "is-active" : ""}`}
      onClick={() => onSelect(tab)}
      aria-label={tab.label}
      title={tab.label}
      aria-current={active ? "page" : undefined}
    >
      <Icon />
    </button>
  );
};

// The app's bottom tab bar (app/components/TabBar/TabBar.js): four tabs and the
// purple "+" in the middle that opens the action menu. As in the app,
// Automation takes Camera's place while the home has the Automation feature.
const TabBar = ({ active, actionsOpen, onActions }) => {
  const history = useHistory();
  const { on: automationOn } = useAutomationFeature();
  const last = automationOn ? TABS[4] : TABS[3];
  const select = (tab) => {
    if (actionsOpen) onActions(false);
    if (history.location.pathname !== tab.path) history.push(tab.path);
  };

  return (
    <nav className="hx-tabbar" aria-label="Main">
      <Tab tab={TABS[0]} active={active === "home"} onSelect={select} />
      <Tab tab={TABS[1]} active={active === "floors"} onSelect={select} />
      <div className="hx-tab-fab-wrap">
        <button
          type="button"
          className={`hx-tab-fab ${actionsOpen ? "is-open" : ""}`}
          onClick={() => onActions(!actionsOpen)}
          aria-label={actionsOpen ? "Close actions" : "Open actions"}
          aria-expanded={actionsOpen}
          aria-controls="hx-actions"
        >
          <IoAdd />
        </button>
      </div>
      <Tab tab={TABS[2]} active={active === "devices"} onSelect={select} />
      <Tab tab={last} active={active === last.key} onSelect={select} />
    </nav>
  );
};

export default TabBar;
